import "./styles/style.scss";
import { startIframeResizeObserver } from "./utils/iframe-resizer.js";
import Swiper from "swiper";
import { Navigation, Pagination, Grid } from "swiper/modules";

// CSS-Imports
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/grid";

const BREAKPOINT_MOBILE = 0;
const BREAKPOINT_TABLET = 768;
const BREAKPOINT_DESKTOP = 920;

const swiperConfig = {
  modules: [Navigation, Pagination, Grid],
  direction: "horizontal",
  loop: false,
  slidesPerView: 3,
  slidesPerGroup: 3,
  spaceBetween: 14,
  updateOnWindowResize: true,

  breakpoints: {
    [BREAKPOINT_MOBILE]: { slidesPerView: 3, slidesPerGroup: 3, grid: { rows: 2 } },
    [BREAKPOINT_TABLET]: { slidesPerView: 6, slidesPerGroup: 6, grid: { rows: 1 } },
    [BREAKPOINT_DESKTOP]: { slidesPerView: 8, slidesPerGroup: 8, grid: { rows: 1 } },
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  on: {
    init: handleNavigationButtons,
    slideChange: handleNavigationButtons,
  },
};

function handleNavigationButtons() {
  const prevButton = document.querySelector(".swiper-button-prev");
  const nextButton = document.querySelector(".swiper-button-next");

  if (!prevButton || !nextButton) return;

  if (this.isBeginning) {
    prevButton.classList.add("disabled");
    nextButton.classList.remove("disabled");
  } else if (this.isEnd) {
    prevButton.classList.remove("disabled");
    nextButton.classList.add("disabled");
  } else {
    prevButton.classList.remove("disabled");
    nextButton.classList.remove("disabled");
  }
}

function initSwiper() {
  const swiperElement = document.querySelector(".swiperspiele");

  if (!swiperElement) {
    console.error("Swiper element not found");
    return null;
  }

  return new Swiper(swiperElement, swiperConfig);
}

document.addEventListener("DOMContentLoaded", () => {
  const swiper = initSwiper();
  if (swiper) {
    console.log("Spieleswiper initialized:", swiper);

    startIframeResizeObserver();
  }
});

export { initSwiper, swiperConfig };
